module.exports = [{"dataLink":"MU3qW-oLjsg"},{"dataLink":"ZJ4Gs1ZLWRk"},{"dataLink":"TtrZKqpn43w"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/videos.json
// module id = RnHR
// module chunks = 1